// Instant hover tooltips for icon-only nav rails (Larry 2026-08-06 /
// 2026-08-11: "I don't know what they all mean").
//
// Same look as the [data-tip] lock tooltips, but a single floating element
// appended to <body> and positioned beside the hovered icon — the sidebars
// scroll (overflow-y: auto), so a CSS ::after bubble would be clipped at the
// rail's edge. Reads each item's own label span; nothing to maintain per item.
// Shows ONLY while the label is hidden (collapsed rail) — when the sidebar is
// expanded the name is already on screen.
export function attachNavTooltips(root, itemSelector) {
  let tip = null

  const ensureTip = () => {
    if (tip) return tip
    tip = document.createElement("div")
    tip.className = "nav-hover-tip"
    tip.setAttribute("role", "tooltip")
    document.body.appendChild(tip)
    return tip
  }

  // Prefer the real label class; else first span that is neither a counter
  // nor an icon/badge wrapper — the Pending Items link leads with its
  // badge wrapper span, which made this grab the badge and never show the
  // hover name when collapsed (Phelipe 2026-08-20).
  const labelEl = (item) =>
    item.querySelector(".sidebar-nav-label") ||
    item.querySelector("span:not([class*='counter']):not([class*='icon'])")

  const labelFor = (item) => {
    // A static title= would double up with ours — keep it as the fallback
    // label but take it off the element.
    if (item.title) {
      item.dataset.navTip = item.title
      item.removeAttribute("title")
    }
    return labelEl(item)?.textContent?.trim() || item.dataset.navTip || ""
  }

  const labelHidden = (item) => {
    const el = labelEl(item)
    return !el || el.offsetWidth === 0
  }

  const hide = () => { if (tip) tip.classList.remove("visible") }

  const show = (item) => {
    if (!labelHidden(item)) return
    const label = labelFor(item)
    if (!label) return

    const el = ensureTip()
    el.textContent = label
    const rect = item.getBoundingClientRect()
    el.style.left = `${Math.round(rect.right + 8)}px`
    el.style.top = `${Math.round(rect.top + rect.height / 2)}px`
    el.classList.add("visible")
  }

  const onOver = (e) => {
    const item = e.target.closest(itemSelector)
    if (item && root.contains(item)) show(item)
  }
  const onOut = (e) => {
    if (e.target.closest(itemSelector)) hide()
  }

  root.addEventListener("mouseover", onOver)
  root.addEventListener("mouseout", onOut)
  root.addEventListener("click", hide)
  // The rails scroll; a fixed-position tip would drift from its icon.
  document.addEventListener("scroll", hide, true)

  return () => {
    root.removeEventListener("mouseover", onOver)
    root.removeEventListener("mouseout", onOut)
    root.removeEventListener("click", hide)
    document.removeEventListener("scroll", hide, true)
    tip?.remove()
    tip = null
  }
}
